import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { font } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { visuallyHidden } from '../utils/visuallyHidden';
import { Label } from '../Label';
import { Layout } from '../Layout';
import { Link } from '../Link';
var FieldRow = styled(Layout, {
    shouldForwardProp: function (prop) { return prop !== 'shouldHideLabel'; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: min-content; // Safari treatment\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  cursor: default;\n\n  ", "\n"], ["\n  min-height: min-content; // Safari treatment\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  cursor: default;\n\n  ", "\n"])), font.label.size, font.label['line-height'], function (_a) {
    var shouldHideLabel = _a.shouldHideLabel;
    return shouldHideLabel && visuallyHidden;
});
export var FormField = styled(React.forwardRef(function (_a, ref) {
    var htmlFor = _a.htmlFor, className = _a.className, label = _a.label, link = _a.link, onLinkClick = _a.onLinkClick, shouldHideLabel = _a.shouldHideLabel, isNotFullWidth = _a.isNotFullWidth, children = _a.children, htmlAttributes = __rest(_a, ["htmlFor", "className", "label", "link", "onLinkClick", "shouldHideLabel", "isNotFullWidth", "children"]);
    return (React.createElement(Layout, __assign({}, htmlAttributes, { ref: ref, className: className, direction: "column", spacing: "x-small" }),
        React.createElement(FieldRow, { shouldHideLabel: shouldHideLabel, shouldWrap: true, align: "start", justify: "between" },
            React.createElement(Label, { htmlFor: htmlFor, size: "small" }, label),
            link && React.createElement(Link, { onClick: onLinkClick }, link)),
        children));
}))(function (_a) {
    var isNotFullWidth = _a.isNotFullWidth;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    display: inline-flex;\n    width: 100%;\n\n    & input {\n      box-sizing: border-box;\n    }\n\n    ", "\n  "], ["\n    ", "\n    display: inline-flex;\n    width: 100%;\n\n    & input {\n      box-sizing: border-box;\n    }\n\n    ", "\n  "])), fontStack, isNotFullWidth && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: auto;\n    "], ["\n      width: auto;\n    "]))));
});
FormField.propTypes = {
    htmlFor: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    isNotFullWidth: PropTypes.bool,
    link: PropTypes.node,
    onLinkClick: PropTypes.func,
    shouldHideLabel: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=FormField.js.map